import PropTypes from 'prop-types';

import Product from '@common/containers/Product';

import { useLookbookSliderContext } from './lookbookSliderContext';
import { Item } from './LookbookProductsListSlider.styled';

const SingleLookbookSliderItem = ({ product, sliderIndex, productIndex }) => {
  const { refs } = useLookbookSliderContext();

  return (
    <Item
      ref={el => (refs.current[productIndex] = { el, slideIndex: sliderIndex })}
    >
      <Product
        imageWidths={[491, 450, 380, 340, 280, 491, 491, 480, 375]}
        {...product}
      />
    </Item>
  );
};

SingleLookbookSliderItem.propTypes = {
  product: PropTypes.shape({ productColorId: PropTypes.string }).isRequired,
  sliderIndex: PropTypes.number.isRequired,
  productIndex: PropTypes.number.isRequired,
};

export default SingleLookbookSliderItem;
